import React, { useRef } from 'react';
import ProTable from '@ant-design/pro-table';
import { Card, Image } from 'antd';
import { getExpenditureDetailPage } from '@/services/merchantSettlement';

const ExpenditureDetail = (props) => {
  // eslint-disable-next-line react/prop-types
  const { merchantId, settlementId, ...otherParams } = props;
  const actionRef = useRef();

  // 支出类型映射（根据需求：1-商家自主提现，2-平台主动结算）
  const settlementTypeMap = {
    1: '商家自主提现',
    2: '平台主动结算',
  };

  const isImageUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const lower = url.toLowerCase();
    if (lower.startsWith('data:image/')) return true;
    const exts = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.svg'];
    try {
      const u = new URL(url, window.location.origin);
      const pathname = u.pathname.toLowerCase();
      return exts.some((ext) => pathname.endsWith(ext));
    } catch (e) {
      return exts.some((ext) => lower.endsWith(ext));
    }
  };

  const columns = [
    {
      title: '提现时间',
      dataIndex: 'ctime',
      hideInSearch: true,
    },
    {
      title: '操作来源',
      dataIndex: 'settlementType',
      hideInSearch: true,
      render: (text) => settlementTypeMap[text] || text,
    },

    {
      title: '金额（税后）',
      dataIndex: 'userAmount',
      hideInSearch: true,
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      hideInSearch: true,
    },
    {
      title: '提现账号',
      dataIndex: 'paymentAccount',
      hideInSearch: true,
    },
    {
      title: '发票信息',
      dataIndex: 'receiptUrl',
      hideInSearch: true,
      render: (_, record) => {
        const { receiptUrl } = record;
        if (!receiptUrl) return '-';
        return isImageUrl(receiptUrl) ? (
          <Image src={receiptUrl} height="80px" />
        ) : (
          <a href={receiptUrl} target="_blank" rel="noopener noreferrer">查看</a>
        );
      },
    },
    {
      title: '打款状态',
      dataIndex: 'userStatus',
      hideInSearch: true,
    },
  ];

  return (
    <Card>
      <ProTable
        actionRef={actionRef}
        columns={columns}
        toolBarRender={false}
        search={false}
        request={async (params) => {
          // 分页参数封装（参考现有页面传参方式）
          const { current, pageSize } = params;
          const response = await getExpenditureDetailPage({
            requestData: {
              merchantId,
              settlementId,
              ...otherParams,
              status: params.status ? Number(params.status) : '',
            },
            page: {
              currentPage: current,
              pageSize: pageSize,
            },
          });

          if (response.code !== '00000') {
            return { success: false };
          }

          return {
            data: response.data,
            success: true,
            total: response.page.count,
          };
        }}
        pagination={{
          defaultPageSize: 20, // 每页20条
          showSizeChanger: false,
        }}
        scroll={{ x: 'max-content' }}
        rowKey="id" // 假设接口返回唯一标识id，若不同需调整
      />
    </Card>
  );
};

export default ExpenditureDetail;
